import { createI18n } from 'vue-i18n'
// 1. 导入语言包
import en from '/src/assets/json/locales/en.json'
import zh from '@/assets/json/locales/zh.json'
import ml from '@/assets/json/locales/ml.json'



// 创建 i18n 实例
const i18n = createI18n({
    legacy: false,           // Vue 3 必须设为 false，启用 Composition API 模式
    globalInjection: true,   // 全局注入 $t 函数，模板中可直接使用
    locale: 'zh',           // 设置默认语言
    fallbackLocale: 'zh',   // 设置回退语言，当当前语言缺失翻译时使用
    messages: {
        en,
        zh,
        ml
    }
})

export default i18n